function parseParticipant(value) {
  if (
    value === null
    || typeof value !== "object"
    || Array.isArray(value)
    || Object.keys(value).sort().join(",") !== "activate,rollback,schemaVersion"
    || value.schemaVersion !== 1
    || typeof value.activate !== "function"
    || typeof value.rollback !== "function"
  ) {
    throw new TypeError(
      "calculator presentation revision participant must contain schemaVersion, activate, rollback",
    );
  }
  return value;
}

export function createCalculatorPresentationRevision() {
  let participant = null;
  let state = "preparing";
  const boundary = Object.freeze({
    accept(value) {
      if (state !== "preparing") {
        throw new Error("calculator presentation revision is no longer accepting a participant");
      }
      if (participant !== null) {
        throw new Error("calculator presentation revision already has a participant");
      }
      participant = parseParticipant(value);
    },
  });
  return Object.freeze({
    boundary,
    seal() {
      if (state !== "preparing") {
        throw new Error("calculator presentation revision cannot be sealed twice");
      }
      state = "prepared";
    },
    activate() {
      if (state !== "prepared") {
        throw new Error("calculator presentation revision is not prepared for activation");
      }
      state = "active";
      participant?.activate();
    },
    finalize() {
      if (state !== "active") {
        throw new Error("calculator presentation revision is not active");
      }
      participant = null;
      state = "finalized";
    },
    rollback() {
      if (state === "rolledBack") {
        return;
      }
      if (state === "finalized") {
        throw new Error("finalized calculator presentation revision cannot be rolled back");
      }
      const accepted = participant;
      participant = null;
      state = "rolledBack";
      accepted?.rollback();
    },
  });
}
